<!-- Container do Editor JSON -->
<div class="json-editor-container" [style.height]="height">
  
  <!-- Barra de Ferramentas -->
  <div class="json-editor-toolbar" *ngIf="!readOnly">
    <div class="toolbar-left">
      <!-- Status de Validação -->
      <nz-tag [nzColor]="validationResult.isValid ? 'success' : 'error'" class="validation-status">
        <nz-icon [nzType]="validationResult.isValid ? 'check-circle' : 'close-circle'" nzTheme="outline"></nz-icon>
        {{ validationResult.isValid ? 
           ('builderScreen.jsonEditor.valid' |translateTA) : 
           ('builderScreen.jsonEditor.invalid' |translateTA) }}
      </nz-tag>

      <!-- Indicador de Modo de Edição -->
      <nz-tag *ngIf="isEditorMode" nzColor="processing" class="editor-mode-indicator">
        <nz-icon nzType="edit" nzTheme="outline"></nz-icon>
        {{ 'builderScreen.jsonEditor.editing' |translateTA }}
      </nz-tag>
    </div>

    <div class="toolbar-right">
      <!-- Botão Formatar -->
      <button 
        nz-button 
        nzType="default" 
        nzSize="small"
        [nzLoading]="isLoading"
        [disabled]="!validationResult.isValid"
        (click)="formatJson()"
        nz-tooltip 
        [nzTooltipTitle]="'builderScreen.jsonEditor.format' |translateTA">
        <nz-icon nzType="align-left" nzTheme="outline"></nz-icon>
      </button>

      <!-- Botão Copiar -->
      <button 
        nz-button 
        nzType="default" 
        nzSize="small"
        [nzLoading]="isLoading"
        (click)="copyToClipboard()"
        nz-tooltip 
        [nzTooltipTitle]="'builderScreen.json.copy' |translateTA">
        <nz-icon nzType="copy" nzTheme="outline"></nz-icon>
      </button>
    </div>
  </div>

  <!-- Área de Erro de Validação -->
  <div class="validation-error" *ngIf="!validationResult.isValid && validationResult.error">
    <nz-alert 
      nzType="error" 
      [nzMessage]="'builderScreen.jsonEditor.validationError' |translateTA"
      [nzDescription]="getValidationErrorDescription()"
      nzShowIcon
      nzCloseable>
    </nz-alert>
  </div>

  <!-- Loading Spinner -->
  <div class="editor-loading" *ngIf="isLoading">
    <nz-spin nzSize="large" [nzTip]="'builderScreen.jsonEditor.loading' |translateTA"></nz-spin>
  </div>

  <!-- Editor ACE -->
  <div 
    #editor 
    class="ace-editor"
    [class.editor-error]="!validationResult.isValid"
    [class.editor-readonly]="readOnly"
    [style.height]="'calc(100% - ' + (readOnly ? '0px' : '80px') + ')'">
  </div>

  <!-- Rodapé com Informações -->
  <div class="json-editor-footer" *ngIf="showValidation">
    <div class="footer-info">
      <span class="info-item">
        <nz-icon nzType="file-text" nzTheme="outline"></nz-icon>
        {{ getLineCount() }} {{ 'builderScreen.jsonEditor.lines' |translateTA }}
      </span>
      
      <span class="info-item" *ngIf="!validationResult.isValid && validationResult.line">
        <nz-icon nzType="environment" nzTheme="outline"></nz-icon>
        {{ 'builderScreen.jsonEditor.line' |translateTA }}: {{ validationResult.line }}
        {{ 'builderScreen.jsonEditor.column' |translateTA }}: {{ validationResult.column }}
      </span>
      
      <span class="info-item">
        <nz-icon nzType="file-done" nzTheme="outline"></nz-icon>
        {{ getCharacterCount() }} {{ 'builderScreen.jsonEditor.characters' |translateTA }}
      </span>
    </div>
  </div>
</div>





































